export default "__VITE_ASSET__CUWFQvsw__"